import React from 'react';
import { Checkbox } from '@attentive-platform/stem-ui';
import { StyledBreakWordContainer } from '../../styled';
import { BULK_TAKEOFF_COLOR, BULK_TAKEOFF_ENTERPRISE_STATUS } from '../../Constants/Constants';

export const getFolderRequestsColumns = (selectedRows, setSelectedRows) => {
  const columns = [
    {
      Header: '',
      accessor: 'select',
      width: 40,
      Cell: ({ row }) => (
        <div className='flex justify-center'>
          <Checkbox
            checked={selectedRows.includes(row.original.id)}
            onChange={() => {
              setSelectedRows(prevState =>
                prevState.includes(row.original.id)
                  ? prevState.filter(id => id !== row.original.id)
                  : [...prevState, row.original.id]
              );
            }}
          />
        </div>
      )
    },
    {
      Header: 'Takeoff address',
      accessor: 'address',
      Cell: ({ row }) => (
        <div className='flex'>
          <StyledBreakWordContainer>{row.original.address}</StyledBreakWordContainer>
        </div>
      )
    },
    {
      Header: 'Takeoff type',
      accessor: 'report_type',
      Cell: ({ row }) => {
        return <div className='flex justify-center'>{row.original.report_type || 'NONE'}</div>;
      },
      align: 'center'
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ row }) => {
        const status = row.original.bulk_action_status;
        return (
          <div
            className='flex justify-center align-center'
            style={{
              color: BULK_TAKEOFF_COLOR[status],
              background: `${BULK_TAKEOFF_COLOR[status]}1A`,
              borderRadius: 6,
              padding: '0px 6px'
            }}>
            <span>{BULK_TAKEOFF_ENTERPRISE_STATUS[status]?.toUpperCase()}</span>
          </div>
        );
      },
      align: 'center'
    }
  ];

  return columns;
};
